package org.example.project.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.layout.*
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import org.example.project.PrimaryColor
import org.example.project.LicensePackageDocument

@Composable
fun LicensePackagesSection(licensePackages: List<LicensePackageDocument>, currentUserLevel: Int) {
    Card(
        colors = CardDefaults.cardColors(containerColor = Color.White),
        elevation = CardDefaults.cardElevation(defaultElevation = 2.dp)
    ) {
        Column(modifier = Modifier.padding(24.dp).fillMaxWidth()) {
            Text(
                text = "Volume Licensing Plans",
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = Color(0xFF64748B) // Slate 500
            )
            Spacer(modifier = Modifier.height(16.dp))
            
            if (licensePackages.isEmpty()) {
                Text("No volume licensing plans available.", color = Color(0xFF64748B), style = MaterialTheme.typography.bodySmall)
            } else {
                Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                    licensePackages.forEach { plan ->
                        val isLocked = currentUserLevel < plan.required_level
                        
                        Surface(
                            color = if (isLocked) Color(0xFFF1F5F9) else Color(0xFFF8FAFC),
                            shape = MaterialTheme.shapes.small,
                            border = BorderStroke(1.dp, if (isLocked) Color(0xFFE2E8F0) else Color(0xFFCBD5E1)),
                            modifier = Modifier.fillMaxWidth().alpha(if (isLocked) 0.6f else 1f)
                        ) {
                            Row(
                                modifier = Modifier.padding(16.dp).fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Column(modifier = Modifier.weight(1f)) {
                                    Text(
                                        text = "${plan.bonus_units} Volume Licenses",
                                        style = MaterialTheme.typography.titleMedium,
                                        fontWeight = FontWeight.Bold,
                                        color = if (isLocked) Color(0xFF94A3B8) else Color(0xFF334155)
                                    )
                                    
                                    Spacer(modifier = Modifier.height(2.dp))
                                    Text(
                                        text = "Corporate Tier Agreement",
                                        style = MaterialTheme.typography.labelSmall,
                                        color = Color(0xFF94A3B8) // Slate 400
                                    )
                                    
                                    Spacer(modifier = Modifier.height(6.dp))
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        if (isLocked) {
                                            Icon(
                                                imageVector = Icons.Default.Lock,
                                                contentDescription = "Locked",
                                                modifier = Modifier.size(12.dp),
                                                tint = Color(0xFFEF4444) // Red 500
                                            )
                                            Spacer(modifier = Modifier.width(4.dp))
                                            Text(
                                                text = "Unlocks at Tier ${plan.required_level}",
                                                style = MaterialTheme.typography.bodySmall,
                                                color = Color(0xFFEF4444),
                                                fontWeight = FontWeight.Medium
                                            )
                                        } else {
                                            Text(
                                                text = "Tier ${plan.required_level} (Unlocked)",
                                                style = MaterialTheme.typography.bodySmall,
                                                color = Color(0xFF64748B)
                                            )
                                        }
                                    }
                                }
                                Spacer(modifier = Modifier.width(8.dp))
                                Column(horizontalAlignment = Alignment.End) {
                                    Text(
                                        text = "Contract Rate",
                                        style = MaterialTheme.typography.labelSmall,
                                        color = Color(0xFF94A3B8)
                                    )
                                    Text(
                                        text = "$${plan.price_usd}",
                                        style = MaterialTheme.typography.titleMedium,
                                        color = if (isLocked) Color(0xFF94A3B8) else PrimaryColor,
                                        fontWeight = FontWeight.Bold,
                                        maxLines = 1
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
